export const permissionsSub = [
  'view_das',
  'view_est',
  'add_est',
  'view_fun',
  'add_fun',
  'view_tre',
  'view_per',
  'view_emp',
  'view_ext',
  'view_epi'
]

export const permissionsUser = [
  'view_das',
  'view_est',
  'view_fun',
  'view_per'
]

export const permissionsManager = [
  'view_das',
  'view_est',
  'add_est',
  'edit_est',
  'view_fun',
  'add_fun',
  'edit_fun',
  'view_tre',
  'view_per',
  'edit_per',
  'view_emp',
  'edit_emp',
  'view_aso',
  'view_ext',
  'view_col',
  'add_col',
  'edit_col',
  'edit_col',
  'view_epi'
]
